import React, { Component } from 'react'
import { Form } from 'redux-form'
import OperatorField from '../components/OperatorField'
import TimezoneField from '../components/TimezoneField'
import cn from 'classnames'
import Button from 'components/Button'
import SelectPretty from 'components/Input/SelectPretty'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

const dayOptions = [
  {
    name: 'Monday',
    value: 'monday',
  },
  {
    name: 'Tuesday',
    value: 'tuesday',
  },
  {
    name: 'Wednesday',
    value: 'wednesday',
  },
  {
    name: 'Thursday',
    value: 'thursday',
  },
  {
    name: 'Friday',
    value: 'friday',
  },
  {
    name: 'Saturday',
    value: 'saturday',
  },
  {
    name: 'Sunday',
    value: 'sunday',
  },
]

export default class DayIsForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, formData, change } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          Often, this node will be used along side 'Time is' in order to outline different
          experiences for during and outside operating hours.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <OperatorField
          change={change}
          formData={formData}
          operators={['is', 'anyOf']}
          component={SelectPretty}
          options={dayOptions}
        />
        <TimezoneField />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/DayIs/DayIsForm.jsx